import siteConfig from "site-config";
import { Observable } from "rxjs";
import { ajax } from "lib/observable";
import { SUBSCRIPTION } from "constants/action-types";
import { add as snackbarAdd } from "actions/snackbars";
import { formatMessage } from "lib/globalize-util";
import me from "models/me";

export const fetchSubscriptionsEpic = (action$, store) => {
    return action$
        .ofType(SUBSCRIPTION.FETCH.START)
        .map(({ payload }) => payload)
        .flatMap(({ targetFeedId, targetType, merchantId }) => {
            const { collection } = store.getState();
            return ajax({
                url: `${siteConfig.goAPI}/v1/user_notification/users/${
                    me._id
                }/subscriptions/${targetType}/${targetFeedId}?merchant_id=${merchantId || collection.merchantId}`,
                method: "GET",
            })
                .map(({ response }) => response)
                .flatMap((response) => {
                    return [
                        {
                            payload: {
                                results: {
                                    [response.target_feed_id]: response,
                                },
                            },
                            type: SUBSCRIPTION.FETCH.SUCCESS,
                        },
                    ];
                })
                .catch((error) => {
                    if (error.status === 404) {
                        return Observable.merge(
                            Observable.of({
                                payload: {
                                    results: {},
                                },
                                type: SUBSCRIPTION.FETCH.SUCCESS,
                            }),
                        );
                    } else {
                        return Observable.merge(
                            Observable.of({
                                payload: new Error(error),
                                error: true,
                                type: SUBSCRIPTION.FETCH.ERROR,
                            }),
                            Observable.of(
                                snackbarAdd({
                                    message: error.message || formatMessage("Error fetching subscription status"),
                                }),
                            ),
                        );
                    }
                });
        });
};

export const addSubscriptionEpic = (action$, store) => {
    return action$
        .ofType(SUBSCRIPTION.SUBSCRIBE.START)
        .map(({ payload }) => payload)
        .flatMap(({ targetType, targetFeedId }) => {
            const { merchantId } = store.getState().collection;
            return ajax({
                url: `${siteConfig.goAPI}/v1/user_notification/users/${me._id}/subscriptions`,
                method: "PUT",
                body: {
                    target_type: targetType,
                    target_feed_id: targetFeedId,
                    merchant_id: merchantId,
                },
            })
                .map(({ response }) => response)
                .flatMap((userSubscription) => {
                    const results = {
                        [targetFeedId]: userSubscription,
                    };
                    return [
                        {
                            payload: {
                                results,
                            },
                            type: SUBSCRIPTION.SUBSCRIBE.SUCCESS,
                        },
                    ];
                })
                .catch((error) =>
                    Observable.merge(
                        Observable.of({
                            payload: new Error(error),
                            error: true,
                            type: SUBSCRIPTION.SUBSCRIBE.ERROR,
                        }),
                        Observable.of(
                            snackbarAdd({ message: error.message || formatMessage("Error adding subscription") }),
                        ),
                    ),
                );
        });
};

export const removeSubscriptionEpic = (action$, store) => {
    return action$
        .ofType(SUBSCRIPTION.UNSUBSCRIBE.START)
        .map(({ payload }) => payload)
        .flatMap(({ targetType, targetFeedId }) => {
            const { merchantId } = store.getState().collection;
            return ajax({
                url: `${siteConfig.goAPI}/v1/user_notification/users/${me._id}/subscriptions/${targetType}/${targetFeedId}?merchant_id=${merchantId}`,
                method: "DELETE",
            })
                .map(({ response }) => response)
                .flatMap(() => {
                    const results = {
                        [targetFeedId]: undefined,
                    };
                    return [
                        {
                            payload: {
                                results,
                            },
                            type: SUBSCRIPTION.UNSUBSCRIBE.SUCCESS,
                        },
                    ];
                })
                .catch((error) =>
                    Observable.merge(
                        Observable.of({
                            payload: new Error(error),
                            error: true,
                            type: SUBSCRIPTION.UNSUBSCRIBE.ERROR,
                        }),
                        Observable.of(
                            snackbarAdd({ message: error.message || formatMessage("Error adding subscription") }),
                        ),
                    ),
                );
        });
};
